import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { gatewayUrlOf } from '@rb/shared/admin-verses';
import { selectEffectiveGatewayId, useActiveVerseStore } from './active-verse.store';

export function VerseManualInput() {
  const { manager, switching, setActive, setSwitching, setConnectionError } = useActiveVerseStore();
  const gatewayId = useActiveVerseStore(selectEffectiveGatewayId);
  const [alias, setAlias] = useState('');

  const connect = async () => {
    const trimmed = alias.trim();
    if (!trimmed || !manager) return;
    setSwitching(true);
    setConnectionError(null);
    try {
      await manager.switchTo(trimmed, gatewayUrlOf(gatewayId));
      setActive(trimmed);
      window.localStorage.setItem('rb-admin-app:active-verse', trimmed);
    } catch (err) {
      console.error('[VerseManualInput] switch failed:', err);
      setActive(null);
      setConnectionError(err instanceof Error ? err.message : String(err));
    } finally {
      setSwitching(false);
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="verse-manual" className="text-xs text-muted-foreground">
        Custom verse alias
      </Label>
      <div className="flex gap-2">
        <Input
          id="verse-manual"
          value={alias}
          onChange={(e) => setAlias(e.target.value)}
          placeholder="0x...-1234"
          disabled={switching}
          onKeyDown={(e) => {
            if (e.key === 'Enter') void connect();
          }}
        />
        <Button onClick={connect} disabled={!alias.trim() || switching || !manager}>
          {switching ? 'Connecting…' : 'Connect'}
        </Button>
      </div>
    </div>
  );
}
